import React from "react";

const TemarioDiplomaturaGestionTelemedicina = () => {
    return (
        <div className="temario-container border w-100 p-5">
            <b>{"Introducción a la telemedicina"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Definición y conceptos básicos de telemedicina. Historia y evolución de la telemedicina"}</span></li>
                <li><span className="fw-light">{"Marcos regulatorios y éticos. Ventajas y desventajas de la telemedicina"}</span></li>
                <li><span className="fw-light">{"Tipos de telemedicina: teleconsulta, telemonitoreo, telediagnóstico"}</span></li>
                <li><span className="fw-light">{"Tecnologías de la información y la comunicación en telemedicina"}</span></li>
            </ul>
            <br /><br />
            <b>{"Tecnologías de la información y comunicación en salud"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Infraestructura tecnológica para la telemedicina. Plataformas de teleconsulta y videoconferencia"}</span></li>
                <li><span className="fw-light">{"Registros médicos electrónicos"}</span></li>
                <li><span className="fw-light">{"Aplicaciones móviles en salud (mHealth)"}</span></li>
                <li><span className="fw-light">{"Seguridad y privacidad de la información del paciente"}</span></li>
            </ul>
            <br /><br />
            <b>{"Teleconsulta y telemonitoreo"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Técnicas de comunicación y entrevista en teleconsulta"}</span></li>
                <li><span className="fw-light">{"Manejo de pacientes crónicos a través de telemonitoreo"}</span></li>
                <li><span className="fw-light">{"Dispositivos y sensores para el monitoreo remoto"}</span></li>
                <li><span className="fw-light">{"Evaluación de la calidad de la atención en teleconsulta"}</span></li>
            </ul>
            <br /><br />
            <b>{"Aspectos legales y éticos de la telemedicina"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Legislación vigente en telemedicina"}</span></li>
                <li><span className="fw-light">{"Consentimiento informado y confidencialidad"}</span></li>
                <li><span className="fw-light">{"Responsabilidad profesional y mala praxis"}</span></li>
                <li><span className="fw-light">{"Ética en el uso de tecnologías de la información en salud"}</span></li>
            </ul>
            <br /><br />
            <b>{"Telediagnóstico y telemedicina especializada"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Telemedicina en diferentes especialidades (cardiología, dermatología, neurología, etc.)"}</span></li>
                <li><span className="fw-light">{"Telemedicina en emergencias"}</span></li>
                <li><span className="fw-light">{"Telemedicina en salud mental. FACTORES HUMANOS"}</span></li>
            </ul>
            <br /><br />
            <b>{"Gestión y evaluación de programas de telemedicina"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Planificación y diseño de programas de telemedicina, en ámbito público y privado"}</span></li>
                <li><span className="fw-light">{"Evaluación de la efectividad y costo-eficiencia"}</span></li>
                <li><span className="fw-light">{"Indicadores de calidad y satisfacción del paciente"}</span></li>
                <li><span className="fw-light">{"Financiación y sostenibilidad de programas de telemedicina"}</span></li>
            </ul>
            <br /><br />
            <b>{"Investigación y desarrollo en telemedicina"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Metodología de la investigación en telemedicina"}</span></li>
                <li><span className="fw-light">{"Desarrollo de proyectos de innovación en telemedicina"}</span></li>
                <li><span className="fw-light">{"Inteligencia artificial y aprendizaje automático en telemedicina"}</span></li>
                <li><span className="fw-light">{"Tendencias futuras en telemedicina"}</span></li>
            </ul>
            <br /><br />
            <b>{"Proyecto final"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Dos exámenes parciales"}</span></li>
                <li><span className="fw-light">{"Examen final"}</span></li>
                <li><span className="fw-light">{"Práctica supervisada y visita a centro de monitoreo en telemedicina"}</span></li>
            </ul>
        </div>
    );
};

export default TemarioDiplomaturaGestionTelemedicina;
